import { render, staticRenderFns } from "./homeAbout.vue?vue&type=template&id=03a68e53&"
import script from "./homeAbout.vue?vue&type=script&lang=js&"
export * from "./homeAbout.vue?vue&type=script&lang=js&"
import style0 from "./homeAbout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports